import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { of as observableOf,  Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IActivityLogs, IAllowSupport, ISupportConfiguration } from './support-config-model';
import { ActivityFilter } from '../invitations-service/invitations-model';
import { SupportPeriodType } from '@shared/enums/SupportPeriodType';


@Injectable()
export class SupportConfigsService {

    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'supportconfigs';

    /** GET */
    public getNow(): Observable<SuccessResponse<ISupportConfiguration> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<ISupportConfiguration>>(
                SupportConfigsService.URL  +
                SupportConfigsService.ENDPOINT +
                '/now',
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getActivityLogs(): Observable<SuccessResponse<IActivityLogs> | ErrorResponse> {
        return this.http
        .post<SuccessResponse<IActivityLogs>>(
            SupportConfigsService.URL  +
            SupportConfigsService.ENDPOINT +
            '/activities', {})
        .pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public allow(allowSupport: IAllowSupport): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .post<SuccessResponse<boolean>>(
            SupportConfigsService.URL  +
            SupportConfigsService.ENDPOINT +
            '/allow',
            allowSupport
        ).pipe(
        catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public deny(): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .post<SuccessResponse<boolean>>(
            SupportConfigsService.URL +
            SupportConfigsService.ENDPOINT +
            '/deny',
            {}
        ).pipe(
        catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
